import Hammer from 'hammerjs';

const els = [];
const mcs = [];

function add(el, type, callback) {
	if (typeof type === 'object') {
		for (const i in type) {
			if (type.hasOwnProperty(i)) {
				add(el, i, type[i]);
			}
		}
		return;
	}

	let mc;
	const index = els.indexOf(el);
	if (index > 0) {
		mc = mcs[index];
	} else {
		els.push(el);
		mc = new Hammer.Manager(el);
		mcs.push(mc);
	}

	let rec;
	switch (type) {
		case 'swipeleft':
		case 'swiperight':
			rec = new Hammer.Swipe({
				direction: Hammer.DIRECTION_HORIZONTAL
			});
			break;
		case 'tap':
			rec = new Hammer.Tap();
			break;
		default:
	}
	mc.add(rec);
	mc.on(type, callback);
}

export default {
	add: add
};
